module.exports = __webpack_public_path__ + "img/cloud.8bd7c639.png";